/**
 * created by lei lei
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, DatePicker, Input, Modal, Select, Tabs, Row, Col, Radio, Pagination, message, Empty} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import SpacerBlock from "../spacerBlock/SpacerBlock";
import task from './img/task.png'
import task2 from './img/task2.png'
import relationChoose from './img/relationChoose.png'
import *as actions from "../../../actions/manuscriptPool"
import *as utils from '../../../utils/index'

const {MonthPicker, RangePicker} = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const {TabPane} = Tabs;
const {Search} = Input;

export default class SelectManuscriptPool extends Component {
    static defaultProps = {
        newSecondSelectColor: '#0050B3',
        interviewRole:1,
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.actions = actions;
        this.state = {
            taskTitle: '',
            selectVisible: false,
            selectKey: '新闻报道',
            startDate: null,
            endDate: null,
            searchValue: '',
            page: 1,//当前页
            size: 10,//每页条数,
            showTab: false,
            img: '',
            topBtn: true,
            listData: [],
            count: 0,
            currentChoose: {}
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    showTask(params) {
        this.state.taskTitle = params.taskTitle;//setState会延迟异步
        this.setState({
            taskTitle: params.taskTitle,
            showTab: params.taskTitle === '关联任务',
            img: params.taskTitle === '关联任务' ? task : relationChoose,
            // selectVisible: true,
            // selectKey: '新闻报道',
            //startDate: null,
            // endDate: null,
            // searchValue: '',
            // page: 1,//当前页
            // size: 10,//每页条数,
            topBtn: params.topBtn ? params.topBtn : false,
            // currentChoose:{},
            // listData:[],
            //count:0,
        });
        this.state.selectKey = '新闻报道';
        this.state.page = 1;
        this.state.size = 10;
        this.state.selectVisible = true;
        this.state.startDate = null;
        this.state.endDate = null;
        this.state.searchValue = '';
        this.state.currentChoose = {};
        this.state.listData = [];
        this.state.count = 0;
        this.typeGet();
        setTimeout(() => {
            this.scrollRef && this.scrollRef.scrollToTop();
        });
    }

    //根据类型获取数据
    typeGet() {
        if (this.state.taskTitle === '关联选题') {
            this.topicSelectionList();
        } else {
            this.getTask()
        }
    }

    //获取关联任务
    getTask() {
        let body = {
            start: this.state.page,
            size: this.state.size,
            startDate: this.state.startDate ? utils.formatDate(this.state.startDate) : null,
            endDate: this.state.endDate ? utils.formatDate(this.state.endDate) : null,
            type: this.state.selectKey,
            interviewRole:this.props.interviewRole,

        };
        if (this.state.searchValue) {
            body.queryStr = this.state.searchValue
        }
        let listData = [];
        let count = 0;
        this.actions.myInterviews(body, data => {
            if (data && data.data) {
                listData = data.data;
                count = data.count;
            }
            this.setState({
                listData: listData,
                count: count,
            })
        })
    }

    //获取关联选题
    topicSelectionList() {
        let body = {
            start: this.state.page,
            size: this.state.size,
            tsDirection: 1,//1是我的。开发阶段没数据，用0全部
            tsStartDate: this.state.startDate ? new Date(this.state.startDate).getTime() : null,
            tsEndDate: this.state.endDate ? new Date(this.state.endDate).getTime() : null,

        };
        if (this.state.searchValue) {
            body.queryStr = this.state.searchValue
        }
        let listData = [];
        let count = 0;
        this.actions.topicSelectionList(body, (data) => {
            if (data && data.data) {
                listData = data.data;
                count = data.count;
            }
            this.setState({
                listData: listData,
                count: count,
            })
        })
    }

    render() {
        let newSecondSelectColor = this.props.newSecondSelectColor;
        return (
            <div>

                <Modal className={'selectManuscriptPool'}
                       taskTitle={this.state.taskTitle}
                       visible={this.state.selectVisible}
                       onOk={() => {
                           this.onOk();
                       }}
                       okText={'确认选择'}
                       cancelText={null}
                       width={900}
                       onCancel={() => {
                           this.setState({selectVisible: false})
                       }}
                       footer={<Button type="primary" onClick={() => this.onOk()}>确认选择</Button>}
                >
                    <style>
                        {`
            .selectManuscriptPool .ant-btn-primary{
            background-color:${newSecondSelectColor} !important;
            border-color:${newSecondSelectColor} !important;
            }
                             `}</style>
                    <div style={{height: '65vh'}}>
                        <div style={{display: 'flex', background: '#ffffff', height: 44}}>
                            {this.state.showTab ?
                                <Tabs defaultActiveKey={this.state.selectKey} activeKey={this.state.selectKey}
                                      onChange={(key) => {
                                          this.state.selectKey = key;
                                          if (key === '新闻报道') {
                                              this.state.img = task;
                                          } else {
                                              this.state.img = task2;
                                          }
                                          this.state.page = 1;
                                          this.setState({});
                                          this.typeGet();
                                      }} tabBarGutter={0}>
                                    <TabPane tab={"新闻报道"} key={'新闻报道'}>
                                    </TabPane>
                                    <TabPane tab={"选题策划"} key={'选题策划'}>
                                    </TabPane>
                                </Tabs> : null}
                            <style>
                                {`
            
           .selectManuscriptPool .ant-tabs-tab-active {
                color: ${newSecondSelectColor} !important;
            }
            .selectManuscriptPool .ant-tabs-nav .ant-tabs-tab:hover {
                color: ${newSecondSelectColor} !important;
            }
            .selectManuscriptPool .ant-tabs-ink-bar{
            background-color:${newSecondSelectColor} !important;
            }
                             `}</style>


                            <div style={{
                                marginLeft: 20,
                                marginRight: 20,
                                height: 45,
                                lineHeight: '45px',
                                position: 'absolute',
                                right: 30,
                                display: 'flex'
                            }}>
                                <div style={{marginRight: 10}}>
                                    <div style={{float: 'left', height: 45, lineHeight: '45px'}}>创建时间&nbsp;&nbsp;</div>
                                    <div style={{float: 'left', width: 210, lineHeight: '45px'}}>
                                        <RangePicker
                                            value={[this.state.startDate, this.state.endDate]}
                                            format={dateFormat}
                                            onChange={(date, dateString) => {
                                                this.state.startDate = date[0];
                                                this.state.endDate = date[1];
                                                this.state.page = 1;
                                                this.state.size = 10;
                                                this.typeGet();
                                                this.setState({})
                                            }}
                                        /></div>
                                    <div style={{clear: 'both'}}/>
                                </div>

                                <div style={{}}>
                                    <Search
                                        placeholder="请输入"
                                        value={this.state.searchValue}
                                        onChange={(e) => {
                                            this.setState({
                                                searchValue: e.target.value
                                            })
                                        }}
                                        size="default"
                                        onSearch={value => this.onSearch(value)}
                                    />
                                </div>
                            </div>
                        </div>
                        <div style={{height: "calc(65vh - 65px)"}}>
                            <Scrollbars ref={(scrollRef) => {
                                this.scrollRef = scrollRef
                            }}>
                                {this.state.listData.length === 0 ? <div style={{
                                    height: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}><Empty/></div> : null}
                                {
                                    this.state.listData.map((item, i) => {

                                        return (
                                            <div key={i}>
                                                {i === 0 ? <SpacerBlock height={1}/> : null}
                                                <div style={{}}>
                                                    <Row>
                                                        <Col span={3}>
                                                            <div style={{
                                                                textAlign: 'center',
                                                                height: 79,
                                                                lineHeight: '79px'
                                                            }}>
                                                                <img
                                                                    style={{height: 40, width: 40, borderRadius: 5}}
                                                                    src={this.state.img} alt=""/></div>
                                                        </Col>
                                                        <Col span={19}>
                                                            <div style={{marginTop: 17}}>
                                                                <div style={{
                                                                    position: 'relative', overflow: 'hidden',
                                                                    textOverflow: 'ellipsis', fontWeight: 'bold',
                                                                    whiteSpace: 'nowrap', color: '#2a3a6b', fontSize: 16
                                                                }}>{item.tsName || item.title}</div>
                                                                <div style={{
                                                                    position: 'relative',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    color: '#a4adc8',
                                                                    fontSize: 14,
                                                                    whiteSpace: 'nowrap'
                                                                }}>
                                                                    {item.tsContent || item.content}
                                                                </div>

                                                            </div>
                                                        </Col>
                                                        <Col span={2}>
                                                            <div style={{
                                                                height: 79,
                                                                lineHeight: '79px',
                                                                display: 'flex'
                                                            }}>

                                                                <div onClick={() => {
                                                                    this.setState({
                                                                        currentChoose: item,
                                                                    })
                                                                }} style={{
                                                                    height: 30,
                                                                    width: 30,
                                                                    borderRadius: '50%',
                                                                    border: 'solid 1px #dfe4ea',
                                                                    lineHeight: '30px',
                                                                    margin: 'auto',
                                                                    display: 'flex'
                                                                }}>
                                                                    <div style={{
                                                                        height: 16,
                                                                        width: 16,
                                                                        borderRadius: '50%',
                                                                        margin: 'auto',
                                                                        background: item.id === this.state.currentChoose.id ? newSecondSelectColor : null,
                                                                    }}></div>
                                                                </div>
                                                                {/* <Radio checked={item.id===this.state.currentChoose.id} onChange={() => {
                                                                    this.setState({
                                                                        currentChoose:item,
                                                                    })
                                                                }}/>*/}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <SpacerBlock height={1}/>
                                            </div>
                                        )
                                    })
                                }


                            </Scrollbars>
                            <div style={{padding: 10, float: 'right'}}>
                                <Pagination
                                    showQuickJumper
                                    // defaultCurrent={2}
                                    current={this.state.page}
                                    pageSize={this.state.size}
                                    total={this.state.count}
                                    showTotal={total => `共 ${total} 条`}
                                    showSizeChanger
                                    onChange={(page, pageSize) => this.onChange(page, pageSize)}
                                    onShowSizeChange={(page, pageSize) => {
                                        this.onChange(page, pageSize)
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }

    onOk() {
        //if(this.state.taskTitle==='关联选题'){
        if (!this.state.currentChoose.id) {
            message.info('请选择' + this.state.taskTitle);
            return;
        }
        //}
        let parms = {taskTitle: this.state.taskTitle, topBtn: this.state.topBtn, ...this.state.currentChoose};
        this.props.callBack && this.props.callBack(parms);

        this.setState({

            selectKey: '新闻报道',
            startDate: null,
            endDate: null,
            searchValue: '',
            page: 1,//当前页
            size: 10,//每页条数,topBtn: params.topBtn?params.topBtn:false,
            currentChoose: {},
            listData: [],
            count: 0,
            selectVisible: false
        });
    }

    onChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.typeGet();
    }

    onSearch(value) {
        this.state.searchValue = value;
        this.state.page = 1;
        this.state.size = 10;
        this.typeGet();
    }

}